/** Safari does not focus a button on pointer activation. Establish the invoker
 * before opening so native Escape, form and close() paths restore it consistently.
 * No document listeners or retained references are needed beyond the dialog itself.
 */
export function openDialog(dialog: HTMLDialogElement, invoker: HTMLElement | null): void {
  if (dialog.open) return;
  invoker?.focus({ preventScroll: true });
  dialog.showModal();
}
